import BaseAPI, { querySuffix } from "./BaseAPI";
import { deliveryItemRoute } from "../routes";

export default class DeliveryItemAPI extends BaseAPI {
    constructor(emitterInstance) {
        super(emitterInstance, deliveryItemRoute, "delivery-item");
    }

    async ListForDelivery(deliveryID) {
        return this._request("get", this._url(`?delivery_id=${deliveryID}`));
    }

    async ListAggregatedByStock(params = {}) {
        return this._request("get", this._url(querySuffix({ aggregate: "by-stock", ...params })));
    }
}
